// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Gp9p","col":"styles_col__2BQJY","actions":"styles_actions__3Gr-V","conflict":"styles_conflict__2aIDo"};